import { createSelector } from '@reduxjs/toolkit'

export const wishlistEntities = state => state.wishlist.entities
const wishlistItems = state => state.wishlist.entities.items
const wishlistItemIds = state => state.wishlist.result
const orderTotals = state => state.wishlist.orderTotals

export const wishlistSettings = state => state.wishlist.settings

export const wishlistSelector = createSelector(
    wishlistItemIds,
    wishlistItems,
    wishlistSettings,
    orderTotals,
    (ids, products, settings, orderTotals) => {
        const items = ids.map(id => products[id])
        let quantity = 0

        items.forEach(item => {
            quantity += item.quantity
        })

        return { items, settings, ids, orderTotals, quantity }
    },
)